export default __webpack_public_path__ + "static/media/featureBackground.8ad624a6.png";